import globals from './globals';
import * as PIXI from 'pixi.js';
import { body, html } from './utils/environment';
import LocomotiveScroll from 'locomotive-scroll';
import { initPhotoSwiper, fadeToPhoto, closePhotoSwiper, resizePhotoSwiper, hidePhotoGrid } from './photoswiper';
import { initSound, checkSoundsReady, changeSound, addWaterSound, removeWaterSound, sounds } from './sound';
import $ from "jquery";

// gsap and gsap plugins    
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { Draggable } from "gsap/Draggable.js";
import { SteppedEase, Quad } from "gsap";
import PixiPlugin from "gsap/PixiPlugin";

// register plugins
gsap.registerPlugin(ScrollTrigger, Draggable, PixiPlugin, Quad);
PixiPlugin.registerPIXI(PIXI);

//PROPERTIES
const LANG = document.documentElement.lang;
const UACODE = "UA-37158010-2";

let windowHeight;
let windowWidth;
let isMobile = false;
let locoScrollInitialized = false;
let canChangeSound = true;
let preloader;
let introVideo = document.getElementById("introVideo");
let slideshow = document.getElementById("slideshow");
let pitText = document.getElementById("pitText");
let scaleVariation = 0.3;
let beginBtn = document.getElementById("begin");
let preloadPercInput = document.getElementById("preloadPerc");
let galleryUIWrapper = document.querySelectorAll('.lh-gallery-button-wrapper')[0];
let hand1 = document.querySelectorAll('.c-watch-hand-1')[0];
let hand2 = document.querySelectorAll('.c-watch-hand-2')[0];
let viewPhotos = document.querySelectorAll('.view-photos')[0];
let allPhotos = document.querySelectorAll('.all-photos')[0];
let returnToStory = document.querySelectorAll('.return-story')[0];
let smoothScroll = document.querySelectorAll('.smooth-scroll')[0];
let smoothScrollWrapper = document.querySelectorAll('.smooth-scroll-wrapper')[0];
let draggableGrid;

//Timeouts
let resizeTimeout, resizeCompleteTimeout, resizeOrientationTimeout, soundChangeTimeout;

//resizing elements
let trainAnimation = document.getElementById("trainAnimation");
let snareAnimation = document.getElementById('snareAnimation');
let skinAnimation = document.getElementById('skinAnimation');
let raccoonAnimation = document.getElementById('raccoonAnimation');
let featherAnimation = document.getElementById('featherAnimation');
let hareAnimation = document.getElementById('hareAnimation');
let pondAnimation = document.getElementById("pondAnimation");
let pitBgAnimation = document.getElementById("pitBgAnimation");
let pondBg = document.getElementById('pondBg');
let pondText = document.getElementById('pondText');

//intro animation props
let counter = 1;
let introPlaying = true;
let fps = 15, fpsInterval, startTime, now, then, elapsed;

//PHOTO ORDER
let photoOrder = [15, 20, 27, 17, 24, 18, 1, 4, 25, 29, 0, 2, 3, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 16, 19, 21, 22, 23, 28, 26];
let currentPhotoIndex;

//SCROLL
let locoScroll, direction, position = 0, currentPosition, disableCalls = false, limit, isEnded = false;
let scrollSpeed = 1;

//PRELOAD
let preloadCounter = 0;
let totalPreloadImg;
let preloadPerc = 0;
let preloadComplete = false;
let appInitialized = false;

//AUDIO
let audioInitiated = false;

//TRAIN
const trainScene = new PIXI.Application({width: 1024, height: 768});
const pondScene = new PIXI.Application({width: 570, height: 500});
const pitBgScene = new PIXI.Application({width: 1024, height: 2038});

let Application = PIXI.Application,
    Container = PIXI.Container,
    loader = PIXI.Loader.shared,
    resources = PIXI.Loader.resources,
    TextureCache = PIXI.utils.TextureCache,
    //VoidFilter = PIXI.filters.VoidFilter,
    Sprite = PIXI.Sprite,
    Rectangle = PIXI.Rectangle;

let trainBg, treesLeft, treesRight, treesMid, pit, sky, trainStationForest, trainStation, forestFront, forestBack, trainWrapper, trainStationWrapper, smokeWheels, smokestack;
let track1, track2, track3, track4, trainFog, spruce1, spruce2, spruce3, spruce4, spruce5;
let pondClouds, pondTreeline, pondSurface, pondTop, pondBottom, pondParticles1, pondParticles2, pitBackground, pitFull;
const pondWidth = 570, pitBgWidth = 1024, pitBgHeight = 2038, pitWidth = 547;
let pondScale, pitScale, pitBgScale, pitBgMaxHeight;
trainScene.renderer.backgroundColor = 0xFFFFFF;
pondScene.renderer.backgroundColor = 0xFFFFFF;
pitBgScene.renderer.backgroundColor = 0x000000;


// device detection
if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
    isMobile = true;
    document.getElementsByTagName("html")[0].classList.add('is-mobile');
}



$(document).ready(function () {
    const $style = document.getElementById('main-css');
    consoleLogger("isMobile: " + isMobile);

    

    //set viewport height variable
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    
    //need this iPad test
    //since iOS 13 iPad no longer returns the user agent identifier
    function isIpad() {

        if ((/\b(iPad)\b/.test(navigator.userAgent)
            && /WebKit/.test(navigator.userAgent)
            && !window.MSStream)
            || (navigator.platform === 'MacIntel'
                && navigator.maxTouchPoints
                && navigator.maxTouchPoints === 5)
        ) {
            return true;
        }
    }

    consoleLogger("isIpad: " + isIpad());

    //adjust scroll speed by device
    if(isIpad()){
        scrollSpeed = 0.75;
        isMobile = false; //force iPad to use desktop version
        document.getElementsByTagName("html")[0].classList.remove('is-mobile');
    } else if (isMobile) {
        scrollSpeed = 1;
    }
    
    $( "#gallery" ).load( "images.html" );

    if(isMobile){
        //load images into the mobile gallery at the end
        $( "#galleryEnd" ).load( "images.html" );
    }

    
    //Add NFB Framework
    var indexOptions = {
        currentProjectId: 75,
        inverted: true,
        base_url: {
            fr: "http://ladernierechasse.onf.ca/",
            en: "http://lasthunt.nfb.ca/"
        }
    }


    var aboutBtn = document.getElementById('aboutBtn');
    var creditsBtn = document.getElementById('creditsBtn');
    var closeBtn = document.getElementById('closeBtn');
    aboutBtn.addEventListener('click', function (e) {
        e.preventDefault();
        $('#projectInfo').addClass("open");
        $('#about').addClass("open");
        //window.location = '#/info/project/' + indexOptions.currentProjectId;
        //header.reveal();
        trackPage("About");
    });

    creditsBtn.addEventListener('click', function (e) {
        e.preventDefault();
        $('#projectInfo').addClass("open");
        $('#credits').addClass("open");
        //window.location = '#/info/project/' + indexOptions.currentProjectId;
        //header.reveal();
        trackPage("Credits");
    });

    closeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        $('#credits').removeClass("open");
        $('#about').removeClass("open");
        $('#projectInfo').removeClass("open");
    });
    
    load_framework.init(indexOptions);

    $(document).on("ifw_headerLoaded", function () {
        trackEvent("auto_begin", "LastHunt_2021", "interactive");
    });

    
    //load sounds via howler
    initSound();

    if ($style) {

        if ($style.isLoaded) {
            preloadAssets();
        } else {
            $style.addEventListener('load', (event) => {
                preloadAssets();
            });
        }

    } else {
        console.warn('The "main-css" stylesheet not found');
    }

});

let stateCheck = setInterval(() => {
    consoleLogger("stateCheck: " + document.readyState);
    consoleLogger("checkSoundsReady: " + checkSoundsReady());


    //show begin button if sounds preloaded
    if(checkSoundsReady()){
        gsap.to('.c-preloader--begin', 1, { autoAlpha: 1, delay: 1 });
    }

    if (document.readyState === 'complete' && checkSoundsReady()) {
      clearInterval(stateCheck);
      // The page is fully loaded
        consoleLogger('page is fully loaded');
        
        preloadComplete = true;
        checkStart();
    } 
  }, 100);


function trackPage(pageName) {
    //console.log("trackPage: " + LANG + ", pageName: " + pageName);
    google_analytics.gaTrack({
        language: LANG,
        name: pageName,
        ua_code: UACODE,
        pageview: "page",
    });
}

function trackEvent(event, label, category) {
    //console.log("trackEvent: " + LANG + ", event: " + event + ", label: " + label + ", category: " + category);
    google_analytics.gaTrack({
        language: LANG,
        name: "Last Hunt",
        ua_code: UACODE,
        event: event,
        event_label: label,
        event_category: category
    });
}

function preloadAssets() {
    html.classList.add('is-loaded');
    html.classList.add('is-ready');
    html.classList.remove('is-loading');

    globals();

    //show preloader
    gsap.to('.c-preloader', 1, { autoAlpha: 1 });
    

    beginBtn.addEventListener('click', function () {
        changeSound(sounds.INTRO);
        audioInitiated = true;
        trackEvent("start_button", "start", "engagement");
        checkStart();
    });
    
    let resolution = "small";
    let windowWidth = $(window).width();
    if (windowWidth > 700 && windowWidth < 1024) { 
        resolution = "med";
    } else if (windowWidth > 1024) { 
        resolution = "high"; 
    }
    
    const preloadImageArr = [
        "assets/images/gallery/" + resolution + "/a_hobbs_01.jpg",
        "assets/images/gallery/" + resolution + "/a_hobbs_02.jpg",
        "assets/images/gallery/" + resolution + "/a_hobbs_03.jpg",
        "assets/images/gallery/" + resolution + "/a_hobbs_04.jpg",
        "assets/images/gallery/" + resolution + "/a_hobbs_05.jpg",
        "assets/images/gallery/" + resolution + "/a_hobbs_06.jpg",
        "assets/images/gallery/" + resolution + "/a_hobbs_07.jpg",
        "assets/images/gallery/" + resolution + "/a_hobbs_08.jpg",
        "assets/images/gallery/" + resolution + "/a_hobbs_09.jpg",
        "assets/images/gallery/" + resolution + "/a_hobbs_10.jpg",
        "assets/images/gallery/" + resolution + "/a_hobbs_11.jpg",
        "assets/images/gallery/" + resolution + "/a_hobbs_12.jpg",
        "assets/images/gallery/" + resolution + "/a_hobbs_13.jpg",
        "assets/images/gallery/" + resolution + "/a_hobbs_14.jpg",
        "assets/images/gallery/" + resolution + "/a_hobbs_15.jpg",
        "assets/images/gallery/" + resolution + "/a_hobbs_16.jpg",
        "assets/images/gallery/" + resolution + "/a_hobbs_17.jpg",
        "assets/images/gallery/" + resolution + "/a_hobbs_18.jpg",
        "assets/images/gallery/" + resolution + "/a_hobbs_19.jpg",
        "assets/images/gallery/" + resolution + "/a_hobbs_20.jpg",
        "assets/images/gallery/" + resolution + "/a_hobbs_21.jpg",
        "assets/images/gallery/" + resolution + "/a_hobbs_22.jpg",
        "assets/images/gallery/" + resolution + "/a_hobbs_23.jpg",
        "assets/images/gallery/" + resolution + "/a_hobbs_24.jpg",
        "assets/images/gallery/" + resolution + "/a_hobbs_25.jpg",
        "assets/images/gallery/" + resolution + "/a_hobbs_26.jpg",
        "assets/images/gallery/" + resolution + "/a_hobbs_27.jpg",
        "assets/images/gallery/" + resolution + "/a_hobbs_28.jpg",
        "assets/images/gallery/" + resolution + "/a_hobbs_29.jpg",
        "assets/images/gallery/" + resolution + "/a_hobbs_30.jpg",
        "assets/images/intro/lasthunt_01.png",
        "assets/images/intro/lasthunt_02.png",
        "assets/images/intro/lasthunt_03.png",
        "assets/images/intro/lasthunt_04.png",
        "assets/images/intro/clouds1.png",
        "assets/images/intro/clouds2.png",
        "assets/images/intro/clouds3.png",
        "assets/images/intro/clouds4.png",
        "assets/images/skin/skin-ss-transparent.png",
        "assets/images/snare/branch-sprite.png",
        "assets/images/snare/snare_hook.png",
        "assets/images/snare/snare_test.png",
        "assets/images/snare/snare-loop-sprite.png",
        "assets/images/run/hare-sprite.png",
        "assets/images/train/train_1024a.png",
        "assets/images/train/train_1024b.png",
        "assets/images/raccoon/prisonbarleft.png",
        "assets/images/raccoon/prisonbarright.png",
        "assets/images/raccoon/raccoon_shadow.png",
        "assets/images/pond/pond_1.png",
        "assets/images/pond/pond_2.png",
        "assets/images/pond/pond_3.png",
        "assets/images/pond/pond_4.png",
        "assets/images/pit/pit_bg.jpg",
        "assets/images/pit/pit_full.png",
        "assets/images/feather/feather-1.png",
        "assets/images/feather/feather-2.png",
        "assets/images/feather/feather-3.png",
        "assets/images/feather/feather-4.png",
        "assets/images/feather/feather-5.png",
        "assets/images/ui/view-all-photos.png",
        "assets/images/ui/return-to-story.svg",
        "assets/images/ui/view-photos.svg",
        "assets/images/ui/icon-arrow.svg",
        "assets/images/text/close-x.svg",
        "assets/images/text/fermer-x.svg",
    ];
    

    checkStart();
    
    preloadImages(preloadImageArr).then(function (imgs) {
        // all images are loaded now and in the array imgs
        consoleLogger("preloaded images are loaded");
        checkStart();

    }, function (errImg) {
        consoleLogger("an image failed to load");
        // at least one image failed to load
        checkStart();

    });
    

}

function preloadImages(srcs) {
    function loadImage(src) {
        return new Promise(function (resolve, reject) {
            var img = new Image();
            img.onload = function () {
                resolve(img);
                preloadCounter++;
                preloadPerc = Math.round(preloadCounter / totalPreloadImg * 100);
                preloadPercInput.innerHTML = preloadPerc + "<span class='perc'>%</span>";
                let r2 = preloadCounter / totalPreloadImg * 360 + 10 + 80;
                let r1 = preloadCounter / totalPreloadImg * 40 + 50;
                hand1.style.transform = "scale(0.2) rotate(" + r1 + "deg)";
                hand2.style.transform = "scale(0.3) rotate(" + r2 + "deg)";
            };
            img.onerror = img.onabort = function () {
                reject(src);
            };
            img.src = src;
        });
    }
    var promises = [];
    totalPreloadImg = srcs.length;
    for (var i = 0; i < srcs.length; i++) {
        promises.push(loadImage(srcs[i]));
    }
    return Promise.all(promises);
}

function checkStart() {
    consoleLogger("checkStart > audioInitiated: " + audioInitiated + ", preloadComplete: " + preloadComplete);
    if (audioInitiated && !preloadComplete) {
        //fade out headphones, fade in preloader
        gsap.to('.c-preloader--headphones', 1, { autoAlpha: 0 });
        gsap.to('.c-preloader--watch', 1, { autoAlpha: 1 });
    } else if (audioInitiated && preloadComplete) {
        
        //fade out elements
        gsap.to('.c-preloader--headphones', 1, { autoAlpha: 0, delay: 1 });
        gsap.to('.c-preloader--begin', 0.5, { autoAlpha: 0, delay: 1 });

        gsap.to('.c-preloader', 1, { autoAlpha: 0, delay: 2 });
        gsap.to('.c-swipe-vertical', 0.5, { opacity: 1, delay: 2.75 });
        $('.preload-el').removeClass('preload-el');
        $('.smooth-scroll').removeClass('hide');
        $('.lh-gallery').removeClass('hide');
        setTimeout(function(){
            init();
        }, 1000)
    }
}

function init() {
    //only run this once
    if(appInitialized){
        return;
    }
    appInitialized = true;
    consoleLogger("> > > > > > > > > init");
    trackPage("MainPage");

    //add the photo swiper
    initPhotoSwiper();    

    //add PIXI texture and scenes
    trainAnimation.appendChild(trainScene.view);
    pondAnimation.appendChild(pondScene.view)
    pitBgAnimation.appendChild(pitBgScene.view)

    var spriteA  = PIXI.BaseTexture.from("assets/images/train/train_1024a.png");
    var spriteB  = PIXI.BaseTexture.from("assets/images/train/train_1024b.png");
    var pond1 = PIXI.BaseTexture.from("assets/images/pond/pond_1.png");
    var pond2 = PIXI.BaseTexture.from("assets/images/pond/pond_2.png");
    var pond3 = PIXI.BaseTexture.from("assets/images/pond/pond_3.png");
    var pond4 = PIXI.BaseTexture.from("assets/images/pond/pond_4.png");
    var pitBgSprite = PIXI.BaseTexture.from("assets/images/pit/pit_bg.jpg");
    var pitFullSprite = PIXI.BaseTexture.from("assets/images/pit/pit_full.png");

    function calcElScaleOffset(elPos, elScale) {
        return (elPos - elPos * elScale)/2;
    }
    
    //Pit
    let pitTexture = new PIXI.Texture(spriteA, new Rectangle(947, 1025, 48, 93));
    pit = new Sprite(pitTexture);
    pit.x = 500; //400;
    pit.y = 410; //510;
    pit.alpha = 0;
    trainScene.stage.addChild(pit);

    //station forest
    let trainStationForestTexture = new PIXI.Texture(spriteA, new Rectangle(0, 768, 755, 252));
    trainStationForest = new Sprite(trainStationForestTexture);
    trainStationForest.alpha = 0;
    trainScene.stage.addChild(trainStationForest);

    //train station
    trainStationWrapper = new Container();
    trainStationWrapper.alpha = 0;
    trainStationWrapper.x = -10;
    trainStationWrapper.y = 20; //35;
    trainStationWrapper.scale.set(1.05, 1.08);
    trainScene.stage.addChild(trainStationWrapper);

    let trainStationTexture = new PIXI.Texture(spriteA, new Rectangle(1024, 1024, 1024, 688));
    trainStation = new Sprite(trainStationTexture);
    
    let track1Texture = new PIXI.Texture(spriteB, new Rectangle(0, 1024, 1024, 394));
    let track2Texture = new PIXI.Texture(spriteB, new Rectangle(0, 1418, 1024, 394));
    let track3Texture = new PIXI.Texture(spriteB, new Rectangle(1024, 1024, 1024, 394));
    let trainFogTexture = new PIXI.Texture(spriteB, new Rectangle(1024, 1418, 1009, 394));
    
    track1 = new Sprite(track1Texture);
    track1.x = -883;
    track1.y = 602;
    track2 = new Sprite(track2Texture);
    track2.x = -2597;
    track2.y = 1186;
    track3 = new Sprite(track3Texture);
    track3.x = -1762;
    track3.y = 902;
    track4 = new Sprite(track3Texture);
    track4.x = -3491;
    track4.y = 1489;
    trainFog = new Sprite(trainFogTexture);
    trainFog.x = -510;
    trainFog.y = 740;
    
    trainStationWrapper.addChild(trainStation);
    trainStationWrapper.addChild(track1);
    trainStationWrapper.addChild(track2);
    trainStationWrapper.addChild(track3);
    trainStationWrapper.addChild(track4);
    trainStationWrapper.addChild(trainFog);

    //forst back
    forestBack = new Container(); //new Sprite(forestBackTexture);
    forestBack.x = -500;
    forestBack.y = -75;
    forestBack.alpha = 0;
    trainScene.stage.addChild(forestBack);

    spruce1 = new PIXI.Texture(spriteA, new Rectangle(0, 1024, 154, 512));
    spruce2 = new PIXI.Texture(spriteA, new Rectangle(154, 1024, 150, 512));
    spruce3 = new PIXI.Texture(spriteA, new Rectangle(304, 1024, 243, 512));
    spruce4 = new PIXI.Texture(spriteA, new Rectangle(551, 1024, 187, 512));
    spruce5 = new PIXI.Texture(spriteA, new Rectangle(738, 1024, 209, 512));
    
    //train wrapper
    trainWrapper = new Container();
    trainWrapper.x = 104;
    trainWrapper.y = 376;
    
    //train car 2, 1, engine, smoke-wheels, smokestack
    let trainCarTexture = new PIXI.Texture(spriteA, new Rectangle(492, 1536, 470, 306));
    let trainEngineTexture = new PIXI.Texture(spriteA, new Rectangle(0, 1536, 492, 350));
    let smokeWheelsTexture = new PIXI.Texture(spriteA, new Rectangle(1024, 1713, 758, 302));
    let smokestackTexture = new PIXI.Texture(spriteB, new Rectangle(0, 0, 819, 477));
    let trainCar1 = new Sprite(trainCarTexture);
    let trainCar2 = new Sprite(trainCarTexture);
    let engine = new Sprite(trainEngineTexture);
    let smokeWheels = new Sprite(smokeWheelsTexture);
    let smokestack = new Sprite(smokestackTexture);
    trainCar1.x = 430;
    trainCar1.y = -126;
    trainCar2.x = 835;
    trainCar2.y = -267;
    engine.x = 0;
    engine.y = 0;
    smokeWheels.x = 175;
    smokeWheels.y = 55;
    smokestack.x = 106;
    smokestack.y = -392;
    smokestack.scale.set(1.1, 1.1);

    trainWrapper.addChild(trainCar2);
    trainWrapper.addChild(trainCar1);
    trainWrapper.addChild(engine);
    trainWrapper.addChild(smokeWheels);
    trainWrapper.addChild(smokestack);
    trainScene.stage.addChild(trainWrapper);

    //forest front
    forestFront = new Container(); 
    forestFront.x = 300;
    forestFront.y = 200;
    forestFront.alpha = 0;
    trainScene.stage.addChild(forestFront);

    //treesLeft
    let treesLeftTexture = new PIXI.Texture(spriteA, new Rectangle(1025, 0, 293, 690));
    treesLeft = new Sprite(treesLeftTexture);
    treesLeft.scale.set(0.66, 0.66);
    treesLeft.x = 288 + calcElScaleOffset(293, 0.66);
    treesLeft.y = 30 + calcElScaleOffset(690, 0.66)
    treesLeft.anchor.set(0);
    trainScene.stage.addChild(treesLeft);
    
    //treesMid
    let treesMidTexture = new PIXI.Texture(spriteA, new Rectangle(1318, 0, 349, 716));
    treesMid = new Sprite(treesMidTexture);
    treesMid.position.x = 80 + calcElScaleOffset(349, 0.64)
    treesMid.position.y = -50 + calcElScaleOffset(716, 0.64); //(716 - 716 * 0.64)/2; // + (716 * 0.64);
    treesMid.scale.set(0.64, 0.64);
    trainScene.stage.addChild(treesMid);
    
    //treesRight
    let treesRightTexture = new PIXI.Texture(spriteA, new Rectangle(1667, 432, 165, 334));
    treesRight = new Sprite(treesRightTexture);
    treesRight.x = 538 + calcElScaleOffset(165, 0.8);
    treesRight.y = 193 + calcElScaleOffset(334, 0.8);
    treesRight.scale.set(0.8, 0.8);
    trainScene.stage.addChild(treesRight);

    //sky
    let skyTexture = new PIXI.Texture(spriteB, new Rectangle(1024, 0, 1024, 411));
    sky = new Sprite(skyTexture);
    sky.x = 0;
    sky.y = 0;
    trainScene.stage.addChild(sky);
    
    //traingBg
    let trainBgTexture = new PIXI.Texture(spriteA, new Rectangle(0, 0, 1024, 768));
    trainBg = new Sprite(trainBgTexture);
    trainBg.anchor.set(0.5);
    trainBg.x = 1024/2;
    trainBg.y = 768/2;
    trainScene.stage.addChild(trainBg);

    
    
    //Pond textures
    let pondCloudsTexture = new PIXI.Texture(pond1, new Rectangle(0, 0, 570, 354));
    pondClouds = new Sprite(pondCloudsTexture);
    pondClouds.y = 0; 
    pondScene.stage.addChild(pondClouds);

    let pondTreelineTexture = new PIXI.Texture(pond1, new Rectangle(0, 358, 570, 238));
    pondTreeline = new Sprite(pondTreelineTexture);
    pondScene.stage.addChild(pondTreeline);
    
    let pondSurfaceTexture = new PIXI.Texture(pond2, new Rectangle(0, 0, 570, 103));
    pondSurface = new Sprite(pondSurfaceTexture);
    pondScene.stage.addChild(pondSurface);
    
    let pondTopTexture = new PIXI.Texture(pond2, new Rectangle(0, 103, 570, 921));
    pondTop = new Sprite(pondTopTexture);
    pondScene.stage.addChild(pondTop);
    
    let pondBottomTexture = new PIXI.Texture(pond3, new Rectangle(0, 0, 570, 575));
    pondBottom = new Sprite(pondBottomTexture);
    pondScene.stage.addChild(pondBottom);

    let pondParticlesTexture = new PIXI.Texture(pond4, new Rectangle(0, 0, 570, 1022));
    pondParticles1 = new Sprite(pondParticlesTexture);
    pondParticles1.alpha = 0.5;
    pondParticles1.blendMode = PIXI.BLEND_MODES.MULTIPLY;
    pondScene.stage.addChild(pondParticles1);
    
    pondParticles2 = new Sprite(pondParticlesTexture);
    pondParticles2.alpha = 0.5;
    pondParticles2.blendMode = PIXI.BLEND_MODES.MULTIPLY;
    pondScene.stage.addChild(pondParticles2);
    

    //pitBg
     
    let pitBGTexture = new PIXI.Texture(pitBgSprite, new Rectangle(0, 0, 1024, 2038));
    let pitFullTexture = new PIXI.Texture(pitFullSprite, new Rectangle(0, 0, 547, 1225));
    pitBackground = new Sprite(pitBGTexture);
    pitFull = new Sprite(pitFullTexture);
    pitBgScene.stage.addChild(pitBackground);
    pitBgScene.stage.addChild(pitFull);
    

    resizePixiElements();

    
    //Initialize locoScroll
    if(!locoScrollInitialized){
        locoScroll = new LocomotiveScroll({
            el: document.querySelector(".smooth-scroll"),
            // reloadOnContextChange: true,
            smooth: true,
            //lerp: 1,
            // repeat: true,
            multiplier: scrollSpeed, //1, //set scrolling speed
            touchMultiplier: 1.5, //1.5,
            // for tablet smooth
            tablet: { smooth: true },
            // for mobile
            smartphone: { smooth: true },
            getDirection: true,
            reloadOnContextChange: true
        });

        // tell ScrollTrigger to use these proxy methods for the ".smooth-scroll" element since Locomotive Scroll is hijacking things
        ScrollTrigger.scrollerProxy(".smooth-scroll", {
            scrollTop(value) {
                return arguments.length ? locoScroll.scrollTo(value, 0, 0) : locoScroll.scroll.instance.scroll.y;
            }, // we don't have to define a scrollLeft because we're only scrolling vertically.
            getBoundingClientRect() {
                return { top: 0, left: 0, width: window.innerWidth, height: window.innerHeight };
            },
            pinType: document.querySelector(".smooth-scroll").style.transform ? "transform" : "fixed"
            
        });
        
        locoScrollInitialized = true;
    }

    
   
    
    //Gallery UI listeners
    viewPhotos.addEventListener('click', event => {
        document.getElementsByTagName("html")[0].classList.add('gallery-mode');
        //gsap.to(smoothScroll, 10, { x: "95%", ease: "Quad.easeOut" });
        gsap.to(smoothScrollWrapper, 0.5, { x: "101%", ease: "Quad.easeOut" });
    });

    allPhotos.addEventListener('click', event => {
        //show photo grid
        closePhotoSwiper(isMobile);
    });

    returnToStory.addEventListener('click', event => {
        //go back to the story
        
        consoleLogger("returnToStory");
        smoothScroll.classList.remove("hide");
        document.getElementsByTagName("html")[0].classList.add('has-scroll-init', 'has-scroll-scrolling', 'has-scroll-smooth');
        
        
        if (document.getElementsByTagName("html")[0].classList.contains('is-ended')) {
            //If at the end
            currentPosition = position - windowHeight/2;
            consoleLogger("returnToStory > currentPosition: " + currentPosition);
            setTimeout(function(){
                locoScroll.scrollTo(currentPosition, { duration: 1500 });
            }, 100);

        } else {
            //Otherwise just fade to photo
            setTimeout(function(){
                fadeToPhoto(photoOrder[currentPhotoIndex]);
            },500);
        }
        //gsap.to(smoothScroll, 0.5, { marginLeft: "0", ease: "Quad.easeOut" });
        gsap.to(smoothScrollWrapper, 0.5, { x: "0", ease: "Quad.easeOut" });
        document.getElementsByTagName("html")[0].classList.remove('gallery-mode', "is-ended");
    });



    //Gallery UI functions
    function showNav() {
        consoleLogger("show nav ui");
        galleryUIWrapper.classList.add("show");
        //gsap.to(galleryUIWrapper, 0.2, {autoAlpha: 1});
    }
    function hideNav() {
        consoleLogger("hide nav ui");
        galleryUIWrapper.classList.remove("show");
        //gsap.to(galleryUIWrapper, 0.2, {autoAlpha: 0});
    }

    

    //Animation functions
    function startAnimating() {
        introPlaying = true;
        fpsInterval = 1000 / fps;
        then = Date.now();
        startTime = then;
        animateIntroBg();
    }
    function stopAnimating() {
        introPlaying = false;
        cancelAnimationFrame(animateIntroBg);
        removeWaterSound();
    }
    function tree(_type, _left, _top, _scale) {
        let treeScale = (0.4 * _scale + Math.random() * scaleVariation - (scaleVariation >> 1));
        let zIndex = Math.round(_top / 2 * treeScale);
        let tWidth = _type.width;
        let tHeight = _type.height;
        //let t = '<div class="c-train-a c-train-' + _type + '" style="z-index: ' + zIndex + '; left: ' + _left / 2 + 'px; top: ' + _top / 2 + 'px; transform: scale(' + treeScale + ');"></div>';
        let t = new Sprite(_type);
        t.zOrder = Math.round(_top / 2 * treeScale);
        t.x = _left/2 + calcElScaleOffset(tWidth, treeScale);
        t.y = _top/2 + calcElScaleOffset(tHeight, treeScale);;
        t.scale.set(treeScale);
        return t;
    }
    function fog(_texture, _left, _top, _scale) {
        let zIndex = 300 + Math.round(_top / 2);
        //let f = '<div class="c-train-b c-train-fog" style="z-index: ' + zIndex + '; left: ' + _left / 2 + 'px; top: ' + _top / 2 + 'px; transform: scale(' + _scale + ');"></div>';
        let f = new Sprite(_texture);
        f.zOrder = zIndex;
        f.x = _left/2 + calcElScaleOffset(fogTexture.width, _scale);
        f.y = _top/2 + calcElScaleOffset(fogTexture.width, _scale);
        f.scale.set(_scale);
        return f;
    }
    function addTrees(forest) {


        forest.addChild(tree(spruce5, -4210, 2390, 1));
        forest.addChild(tree(spruce5, -4210, 2390, 1));
        forest.addChild(tree(spruce1, -4150, 2310, 1));
        forest.addChild(tree(spruce2, -4350, 2470, 1));
        forest.addChild(tree(spruce3, -4400, 2520, 1));
        forest.addChild(tree(spruce4, -4620, 2770, 1));
        forest.addChild(tree(spruce5, -4500, 2690, 1));

        forest.addChild(tree(spruce1, 855, 300, 1));
        forest.addChild(tree(spruce1, -215, 397, 1));
        forest.addChild(tree(spruce1, -1104, 887, 1));
        forest.addChild(tree(spruce1, -672, 510, 1));
        forest.addChild(tree(spruce1, -1285, 845, 1));
        forest.addChild(tree(spruce1, -2097, 1221, 1));
        forest.addChild(tree(spruce1, -2895, 2058, 1));
        forest.addChild(tree(spruce1, -3062, 2072, 1));
        forest.addChild(tree(spruce1, -2478, 1714, 1));
        forest.addChild(tree(spruce1, -3465, 2250, 1));
        forest.addChild(tree(spruce1, -3217, 2034, 1));
        forest.addChild(tree(spruce1, -3599, 2042, 1));
        forest.addChild(tree(spruce1, -3966, 2000, 1));
        forest.addChild(tree(spruce1, -4131, 1926, 1));
        forest.addChild(tree(spruce1, -4282, 1861, 1));
        forest.addChild(tree(spruce1, -4863, 2524, 1));
        forest.addChild(tree(spruce1, -4431, 2147, 1));
        forest.addChild(tree(spruce1, -5055, 2346, 1));
        forest.addChild(tree(spruce1, -1191, 975, 1));
        forest.addChild(tree(spruce1, -5331, 2973, 1));
        forest.addChild(tree(spruce1, -5464, 3060, 1));
        forest.addChild(tree(spruce1, -5528, 2878, 1));
        forest.addChild(tree(spruce1, -6416, 3307, 1));
        forest.addChild(tree(spruce1, -5985, 2930, 1));
        forest.addChild(tree(spruce1, -6503, 3395, 1));
        forest.addChild(tree(spruce1, -7214, 4144, 1));
        forest.addChild(tree(spruce1, -7381, 4157, 1));
        forest.addChild(tree(spruce1, -6828, 3800, 1));
        forest.addChild(tree(spruce1, -7784, 4336, 1));
        forest.addChild(tree(spruce1, -7536, 4120, 1));
        forest.addChild(tree(spruce1, -7918, 4128, 1));
        forest.addChild(tree(spruce2, -342, 655, 1));
        forest.addChild(tree(spruce2, -20, 438, 1));
        forest.addChild(tree(spruce2, -785, 738, 1));
        forest.addChild(tree(spruce2, -1336, 989, 1));
        forest.addChild(tree(spruce2, -1778, 1072, 1));
        forest.addChild(tree(spruce2, -2766, 1976, 1));
        forest.addChild(tree(spruce2, -3282, 2165, 1));
        forest.addChild(tree(spruce2, -3494, 1787, 1));
        forest.addChild(tree(spruce2, -4544, 2375, 1));
        forest.addChild(tree(spruce2, -5655, 3075, 1));
        forest.addChild(tree(spruce2, -6097, 3158, 1));
        forest.addChild(tree(spruce2, -7085, 4062, 1));
        forest.addChild(tree(spruce2, -7601, 4251, 1));
        forest.addChild(tree(spruce2, -7813, 3873, 1));
        forest.addChild(tree(spruce2, 521, 316, 1));
        forest.addChild(tree(spruce1, 690, 550, 1));
        forest.addChild(tree(spruce3, -488, 861, 1));
        forest.addChild(tree(spruce3, -149, 575, 1));
        forest.addChild(tree(spruce3, -913, 875, 1));
        forest.addChild(tree(spruce3, -1907, 1209, 1));
        forest.addChild(tree(spruce3, -2244, 1425, 1));
        forest.addChild(tree(spruce3, -3274, 2090, 1));
        forest.addChild(tree(spruce3, -3356, 2073, 1));
        forest.addChild(tree(spruce3, -3817, 2025, 1));
        forest.addChild(tree(spruce3, -3008, 1709, 1));
        forest.addChild(tree(spruce3, -4673, 2512, 1));
        forest.addChild(tree(spruce3, -1529, 1005, 1));
        forest.addChild(tree(spruce3, -7367, 3335, 0.05));
        forest.addChild(tree(spruce3, -6563, 3510, 0.05));
        forest.addChild(tree(spruce3, -5800, 3281, 0.05));
        forest.addChild(tree(spruce3, -6226, 3295, 0.05));
        forest.addChild(tree(spruce3, -7593, 4176, 0.05));
        forest.addChild(tree(spruce3, -7675, 4159, 0.05));
        forest.addChild(tree(spruce3, 376, 522, 1));

        forest.addChild(tree(spruce4, 2776, -20, 1));
        forest.addChild(tree(spruce4, 209, 639, 1));
        forest.addChild(tree(spruce4, 283, 510, 1));
        forest.addChild(tree(spruce4, -396, 589, 1));
        forest.addChild(tree(spruce4, -4269, 2080, 1));
        forest.addChild(tree(spruce4, -973, 923, 1));
        forest.addChild(tree(spruce4, -2640, 1910, 1));
        forest.addChild(tree(spruce4, -557, 486, 1));
        forest.addChild(tree(spruce4, -5769, 3009, 1));
        forest.addChild(tree(spruce4, -6959, 3995, 1));
        forest.addChild(tree(spruce4, 863, 397, 1));
        forest.addChild(tree(spruce4, -225, 823, 1));
        forest.addChild(tree(spruce4, -34, 492, 1));
        forest.addChild(tree(spruce4, -681, 887, 1));
        forest.addChild(tree(spruce4, -3806, 1845, 1));
        forest.addChild(tree(spruce4, -1778, 1345, 1));
        forest.addChild(tree(spruce4, -1570, 1117, 1));
        forest.addChild(tree(spruce4, -2352, 1810, 1));
        forest.addChild(tree(spruce4, -3222, 2250, 1));
        forest.addChild(tree(spruce4, -4743, 2146, 1));
        forest.addChild(tree(spruce4, -7511, 4336, 1));
        forest.addChild(tree(spruce4, -5577, 3261, 1));
        forest.addChild(tree(spruce4, -5993, 3307, 1));
        forest.addChild(tree(spruce4, -6671, 3896, 1));
        forest.addChild(tree(spruce4, 505, 377, 1));

        forest.addChild(tree(spruce5, 2606, -30, 1));
        forest.addChild(tree(spruce5, 763, 665, 1));
        forest.addChild(tree(spruce5, 476, 587, 1));
        forest.addChild(tree(spruce5, 194, 747, 1));
        forest.addChild(tree(spruce5, -4842, 2329, 1));
        forest.addChild(tree(spruce5, -3849, 1995, 1));
        forest.addChild(tree(spruce5, -1083, 692, 1));
        forest.addChild(tree(spruce5, -2077, 1026, 1));
        forest.addChild(tree(spruce5, -2883, 1946, 1));
        forest.addChild(tree(spruce5, -3453, 2138, 1));
        forest.addChild(tree(spruce5, -6335, 3112, 1));
        forest.addChild(tree(spruce5, -7263, 4032, 1));
        forest.addChild(tree(spruce5, -7772, 4224, 1));

        
    }

    addTrees(forestBack);
    addTrees(forestFront);

    // Random trees
    let slope = -1200 / 2873;
    let txs = [spruce1, spruce2, spruce3, spruce4, spruce5];
    let tx;
    let ty;
    let ts;
    let numTrees = 50;//100;

    
    for (i = 0; i < numTrees; i++) {
        var randIndex = Math.floor(Math.random() * 5);
        var posAlongSlope = Math.random() * -3800;
        ty = (posAlongSlope * slope);
        tx = ty / slope + 100;
        ty += (140 + 300);
        // Variation from slope
        ty += (Math.random() * 740 - 370);
        ts = 1 + (Math.random() * scaleVariation - (scaleVariation >> 1));
        forestFront.addChild(tree(txs[randIndex], tx, ty, ts));
        forestBack.addChild(tree(txs[randIndex], tx, ty, ts));
    }

    let fogTexture = new PIXI.Texture(spriteB, new Rectangle(1024, 1418, 1009, 394));
    
    forestBack.addChild(fog(fogTexture, -1300, 300, 0.5));
    forestBack.addChild(fog(fogTexture, -2652, 700, 0.5));
    forestBack.addChild(fog(fogTexture, -3050, 1090, 0.5));
    forestFront.addChild(fog(fogTexture, -1300, 360, 0.5));
    forestFront.addChild(fog(fogTexture, -2460, 720, 0.5));
    forestFront.addChild(fog(fogTexture, -2510, 970, 0.5));
    forestFront.addChild(fog(fogTexture, -3352, 1010, 0.5));
    

    resizeElements();

    startAnimating();

    
    

    // the animation loop calculates time elapsed since the last loop
    // and only draws if your specified fps interval is achieved
    function animateIntroBg() {

        // request another frame
        if (introPlaying) {
            requestAnimationFrame(animateIntroBg);
        }

        // calc elapsed time since last loop
        now = Date.now();
        elapsed = now - then;

        // if enough time has elapsed, draw the next frame
        if (elapsed > fpsInterval) {

            // Get ready for next frame by setting then=now, but also adjust for your
            // specified fpsInterval not being a multiple of RAF's interval (16.7ms)
            then = now - (elapsed % fpsInterval);

            // Put your drawing code here
            $('.c-intro-img').removeClass("show");
            $('.c-intro-bg-' + counter).addClass("show");
            counter++;
            if (counter > 4) {
                counter = 1;
            }
        }
    }

    

    //Pin intro bg
    let introTL = gsap.timeline({
        scrollTrigger: {
            scroller: ".smooth-scroll",
            scrub: true,
            trigger: "#introVideo",
            pin: true,
            anticipatePin: 1,
            start: "top top",
            onEnterBack: startAnimating,
            onLeave: stopAnimating,
            end: "+=250%",
        },
    });
    

    //Pin intro text
    let introTextTL = gsap.timeline({
        scrollTrigger: {
            scroller: ".smooth-scroll",
            scrub: true,
            trigger: ".c-intro-title",
            pin: true,
            anticipatePin: 1,
            start: "top top",
            end: "+=100%",
            onEnter: function () {
                addWaterSound();
            },
            onEnterBack: function () {
                addWaterSound();
            },
        },
    });
    introTL.to(".c-intro-title--overlay", { opacity: 0, ease: "none", duration: 3 }, "-=10");

    
    let snareH = $("#snareAnimation").height();
    let snareOffsetY = $("#snareAnimation").offset().top - $("#snare").offset().top - $(window).height()/2 + snareH/2;
    let snareStartY = "+=" + snareOffsetY + "px";
    
    consoleLogger("snareStartY: " + snareStartY);
    
    //Pin snare
    let snareTL = gsap.timeline({
        scrollTrigger: {
            scroller: ".smooth-scroll",
            scrub: true,
            trigger: "#snare",
            pin: true,
            anticipatePin: 1,
            start: snareStartY,
            end: "+=100%",
        },
    });

    snareTL.to(".c-snare-el.tree-fg", { y: "-75px", ease: "Quad.easeOut", duration: 3 });
    snareTL.to(".c-snare-el.branch-bend", { y: "-75px", ease: "Quad.easeOut", duration: 3 }, 0);
    snareTL.to(".c-snare-el.rope", { y: "-75px", ease: "Quad.easeOut", duration: 3 }, 0);
    snareTL.to(".c-snare-el.bush", { y: "-=30px", ease: "Quad.easeOut", duration: 3 }, 0);
    snareTL.to(".c-snare-el.tree-bg", { y: "-=15px", ease: "Quad.easeOut", duration: 3 }, 0);
    snareTL.to(".c-snare-el.branch-mid", { y: "-=50px", ease: "Quad.easeOut", duration: 3 }, 0);
    snareTL.to(".c-snare-el.branch-top", { y: "-=80px", ease: "Quad.easeOut", duration: 3 }, 0);
    snareTL.fromTo(".c-snare-1.circle", { y: "580px" }, { y: "180px", ease: "Quad.easeOut", duration: 3 }, 0);

    //rope
    snareTL.fromTo(".c-snare-el.rope", { top: "157px", rotate: "-1deg" }, { top: "295px", rotate: "9deg", ease: SteppedEase.config(4) }, 0);

    //bending branch
    snareTL.fromTo(".c-snare-el.branch-bend", { backgroundPosition: "0 0" }, { backgroundPosition: "-1552px 0", ease: SteppedEase.config(4) }, 0);

    //loop
    snareTL.to(".c-snare-loop", { y: "-=75px", ease: "Quad.easeOut", duration: 3 }, 0);
    snareTL.fromTo(".c-snare-loop", { width: "0", height: "85px" }, { width: "208px", height: "85px", ease: SteppedEase.config(6) }, "-=2");
    snareTL.fromTo(".c-snare-loop", { width: "208px", height: "85px" }, { width: "208px", height: "126px", ease: SteppedEase.config(2) }, "-=2");
    snareTL.fromTo(".c-snare-loop", { backgroundPosition: "-208px 0" }, { backgroundPosition: "-624px 0", ease: SteppedEase.config(2) }, "-=2");
    
    //hook in circle
    snareTL.fromTo(".c-snare-hook", { backgroundPosition: "0 0" }, { backgroundPosition: "0 -674px", ease: SteppedEase.config(3) }, 0);
    snareTL.fromTo(".c-snare-hook", { backgroundPosition: "-164px 0" }, { backgroundPosition: "-820px 0", ease: SteppedEase.config(4) }, 0);
    snareTL.fromTo(".c-snare-hook", { backgroundPosition: "-164px -225px" }, { backgroundPosition: "-164px -674px", ease: SteppedEase.config(2) });
    snareTL.fromTo(".c-snare-hook", { backgroundPosition: "-328px -225px" }, { backgroundPosition: "-328px -674px", ease: SteppedEase.config(2) });
    snareTL.fromTo(".c-snare-hook", { backgroundPosition: "-492px -225px" }, { backgroundPosition: "-820px -225px", ease: SteppedEase.config(2) });
    snareTL.fromTo(".c-snare-hook", { backgroundPosition: "-492px -449px" }, { backgroundPosition: "-492px -674px", ease: SteppedEase.config(1) });
    snareTL.fromTo(".c-snare-hook", { backgroundPosition: "-656px -449px" }, { backgroundPosition: "-820px -449px", ease: SteppedEase.config(1) });
    snareTL.fromTo(".c-snare-hook", { backgroundPosition: "-656px -674px" }, { backgroundPosition: "-656px -674px", ease: SteppedEase.config(0) });



    let skinH = $("#skinAnimation").height();
    let skinOffsetY = $("#skinAnimation").offset().top - $("#skin").offset().top - $(window).height()/2 + skinH/2;
    let skinStartY = "+=" + skinOffsetY + "px";

    consoleLogger("skinStartY: " + skinStartY);


    //skin animation
    let skinTL = gsap.timeline({
        scrollTrigger: {
            scroller: ".smooth-scroll",
            scrub: true,
            trigger: "#skin",
            pin: true,
            anticipatePin: 1,
            start: skinStartY,
            end: "+=100%",
            //start: "bottom top",
            //end: "+=50%",
        },
    });
    skinTL.fromTo(".c-skin-animation", { backgroundPosition: "0 0" }, { backgroundPosition: "-3479px 0", ease: SteppedEase.config(7) });
    skinTL.fromTo(".c-skin-animation", { backgroundPosition: "0 -243px" }, { backgroundPosition: "-3479px -243px", ease: SteppedEase.config(7) });
    skinTL.fromTo(".c-skin-animation", { backgroundPosition: "0 -486px" }, { backgroundPosition: "-3479px -486px", ease: SteppedEase.config(7) });
    skinTL.fromTo(".c-skin-animation", { backgroundPosition: "0 -729px" }, { backgroundPosition: "-3479px -729px", ease: SteppedEase.config(7) });
    skinTL.fromTo(".c-skin-animation", { backgroundPosition: "0 -972px" }, { backgroundPosition: "-3479px -972px", ease: SteppedEase.config(7) });
    skinTL.fromTo(".c-skin-animation", { backgroundPosition: "0 -1215px" }, { backgroundPosition: "-3479px -1215px", ease: SteppedEase.config(7) });
    skinTL.fromTo(".c-skin-animation", { backgroundPosition: "0 -1458px" }, { backgroundPosition: "-2982px -1458px", ease: SteppedEase.config(6) });

    


    //Pin Train
    let trainTL = gsap.timeline({
        // yes, we can add it to an entire timeline!
        scrollTrigger: {
            scroller: ".smooth-scroll",
            scrub: true,
            trigger: "#train",
            pin: true,
            anticipatePin: 1,
            start: "top top", // when the top of the trigger hits the top of the viewport
            end: "+=1500%",
            onEnter: function () {
                consoleLogger("TrainTL > onEnter");
                updateSound(sounds.TRAIN);
                trackEvent("percentage_viewed", "percentage", 25);
            },
            onEnterBack: function () {
                consoleLogger("TrainTL > onEnterBack");
                updateSound(sounds.TRAIN);
                
            },
            onLeave: function () {
                consoleLogger("TrainTL > onLeave");
                updateSound(sounds.INTRO);
                trackEvent("percentage_viewed", "percentage", 50);
            },
            onLeaveBack: function () {
                consoleLogger("TrainTL > onLeaveBack");
                updateSound(sounds.INTRO);
            }
        }
    });
    
    
    //Animate train text
    trainTL.to(".c-train", { autoAlpha: 1, ease: "none", duration: 4, onComplete: call, onCompleteParams: [2] })
    .to(trainBg, { pixi: {scale: 1.54, y: "+=50px" }, ease: "Quad.easeInOut", duration: 35 }, 4)
    //.to(treesLeft, { pixi: {scale: 1, x: "-=150px", y: "-=10px", ease: "Quad.easeInOut", duration: 35}}, 4) ///288, 30 (337, 147)
    .to(treesLeft, { pixi: {scale: 1, x: 138, y: 20}, ease: "Quad.easeInOut", duration: 35}, 4) ///288, 30
    //.to(treesMid, { pixi: {scale: 1, x: "-=230px", y: "0", ease: "Quad.easeInOut", duration: 35 }}, 4)
    .to(treesMid, { pixi: {scale: 1, x: -150, y: -50}, ease: "Quad.easeInOut", duration: 35}, 4) //80, -50
    //.to(treesRight, { pixi: {scale: 1, x: "+=66px", y: "-=14px", ease: "Quad.easeInOut", duration: 35}}, 4)
    .to(treesRight, { pixi: {scale: 1, x: 604, y: 179}, ease: "Quad.easeInOut", duration: 35}, 4) //538, 193
    
    //scale up foreground scene
    //1942
    .to(".train-text1", { opacity: 1, ease: "none", duration: 1 }, 4) //"-=35")
    .to(".train-text1", { opacity: 0, ease: "none", duration: 1 }, 9) //"-=31")
    //Took train to montreal
    .to(".train-text2", { opacity: 1, ease: "none", duration: 2 }, 12) //"-=28")
    .to(".train-text2", { opacity: 0, ease: "none", duration: 1 }, 17) //"-=24")
    //One last fling
    .to(".train-text3", { opacity: 1, ease: "none", duration: 1 }, 20) //"-=21")
    .to(".train-text3", { opacity: 0, ease: "none", duration: 1 }, 25) //"-=17")
    //Put a damper on party
    .to(".train-text4", { opacity: 1, ease: "none", duration: 1 }, 28) //"-=14")
    .to(".train-text4", { opacity: 0, ease: "none", duration: 1 }, 33) //"-=9")

    //fade in background scene
    .to([trainStationWrapper, trainStationForest, forestFront, forestBack], { pixi: {autoAlpha: 1}, duration: 5, onComplete: call, onCompleteParams: [3]}, 38)
    //fade out foreground
    .to([trainBg, sky, treesRight, treesLeft, treesMid], { pixi: {autoAlpha: 0 }, duration: 5}, "-=5")
    //train pulls into station
    //.from(trainWrapper, { pixi: {x: 1024, y: -355, duration: 15, ease: "Quad.easeOut" }})
    .from(trainWrapper, { pixi: {x: 1024, y: 37 }, duration: 15, ease: "Quad.easeOut"})
    .to([smokeWheels, smokestack], { pixi: { autoAlpha: 0 }, duration: 4, ease: "none" })
    //at train station
    //Pit was only 22
    .to(".train-text5", { opacity: 1, ease: "none", duration: 1 }, "-=2")
    .to(".train-text5", { opacity: 0, ease: "none", duration: 1 }, "+=12")

    //train leaves (moving background only)
    .to([trainStationWrapper, trainStationForest, forestBack, forestFront], { pixi: {x: "+=2900px", y: "-=1025px"}, duration: 20, ease: "Quad.easeInOut" })
    
    //wild horses
    .to(".train-text6", { opacity: 1, ease: "none", duration: 1 }, "-=15")
    .to(".train-text6", { opacity: 0, ease: "none", duration: 1 }, "-=8")

    //The Canadian army
    .to(".train-text7", { opacity: 1, ease: "none", duration: 1 }, "-=4")
    .to(".train-text7", { opacity: 0, ease: "none", duration: 1 }, "+=7")

    //move train again
    .to(trainWrapper, { pixi: {x: "-=630px", y: "+=217px"}, duration: 15, ease: "Quad.easeInOut" }, "-=4")

    //show pit
    .to(pit, { pixi: {autoAlpha: 1}, ease: "none", duration: 1 })

    //So when his leave was over
    .to(".train-text8", { opacity: 1, ease: "none", duration: 1 }, "-=3")
    .to(".train-text8", { opacity: 0, ease: "none", duration: 1 }, "+=8")

    .to(trainWrapper, { pixi:{x: "-=1450px", y: "+=500px"}, duration: 15, ease: "Quad.easeIn" }, "+=1")
    
    //fade out train
    .to(".c-train", { opacity: 0, ease: "none", duration: 4 }, "+=4")
    



    let raccoonH = $("#raccoonAnimation").height();
    let raccoonOffsetY = $("#raccoonAnimation").offset().top - $("#raccoon").offset().top - $(window).height()/2 + raccoonH/2;
    let raccoonStartY = "+=" + raccoonOffsetY + "px";

    //Pin Raccoon
    let raccoonTL = gsap.timeline({
        scrollTrigger: {
            scroller: ".smooth-scroll",
            scrub: true,
            trigger: "#raccoon",
            pin: true,
            anticipatePin: 1,
            start: raccoonStartY,
            end: "+=100%",
        },
    });
    raccoonTL.from(".c-prisonbar-left", { right: "100%", ease: "Quad.easeOut" }, 0);
    raccoonTL.from(".c-prisonbar-right", { left: "100%", ease: "Quad.easeOut" }, 0);

    let featherH = $("#featherAnimation").height();
    let featherOffsetY = $("#featherAnimation").offset().top - $("#feather").offset().top - $(window).height()/2 + featherH/2;
    let featherStartY = "+=" + featherOffsetY + "px";
    

    //Pin Feather
    let featherTL = gsap.timeline({
        scrollTrigger: {
            scroller: ".smooth-scroll",
            scrub: true,
            trigger: "#feather",
            pin: true,
            anticipatePin: 1,
            start: featherStartY,
            end: "+=200%",
        },
    });
    //featherTL.fromTo(".c-feather-animation", { backgroundPosition: "0 0" }, { backgroundPosition: "-1536px 0", ease: SteppedEase.config(3) }, 0);
    featherTL.fromTo(".c-feather-1", { opacity: 1 }, { opacity: 0, ease: "none", duration: 1 }, 3);
    featherTL.fromTo(".c-feather-2", { opacity: 0 }, { opacity: 1, ease: "none", duration: 1 }, 3);

    featherTL.fromTo(".c-feather-2", { opacity: 1 }, { opacity: 0, ease: "none", duration: 1 }, 6);
    featherTL.fromTo(".c-feather-3", { opacity: 0 }, { opacity: 1, ease: "none", duration: 1 }, 6);

    featherTL.fromTo(".c-feather-3", { opacity: 1 }, { opacity: 0, ease: "none", duration: 1 }, 9);
    featherTL.fromTo(".c-feather-4", { opacity: 0 }, { opacity: 1, ease: "none", duration: 1 }, 9);

    featherTL.fromTo(".c-feather-4", { opacity: 1 }, { opacity: 0, ease: "none", duration: 1 }, 12);
    featherTL.fromTo(".c-feather-5", { opacity: 0 }, { opacity: 1, ease: "none", duration: 1 }, 12);

    featherTL.to(".c-feather-5", { opacity: 1, ease: "none", duration: 1 }, 15);

    let hareH = $("#hareAnimation").height();
    let hareOffsetY = $("#hareAnimation").offset().top - $("#hare").offset().top - $(window).height()/2 + hareH/2;
    let hareStartY = "+=" + hareOffsetY + "px";
    

    //Pin Hare
    let hareTL = gsap.timeline({
        scrollTrigger: {
            scroller: ".smooth-scroll",
            scrub: true,
            trigger: "#hare",
            pin: true,
            anticipatePin: 1,
            start: hareStartY,
            end: "+=150%",
            onEnter: function () {
                trackEvent("percentage_viewed", "percentage", 75);
            },
        },
    });
    hareTL.fromTo(".c-hare-animation", { backgroundPosition: "0 0" }, { backgroundPosition: "-5120px 0", ease: SteppedEase.config(10) }, 0)
        .fromTo(".c-hare-animation", { backgroundPosition: "0 0" }, { backgroundPosition: "-5120px 0", ease: SteppedEase.config(10) })
        .fromTo(".c-hare-animation", { backgroundPosition: "0 0" }, { backgroundPosition: "-5120px 0", ease: SteppedEase.config(10) })
        .fromTo(".c-hare-animation", { backgroundPosition: "0 0" }, { backgroundPosition: "-5120px 0", ease: SteppedEase.config(10) });



    //Pin Pond
    let pondTL = gsap.timeline({
        // yes, we can add it to an entire timeline!
        scrollTrigger: {
            scroller: ".smooth-scroll",
            scrub: true,
            trigger: "#pondBg",
            pin: true,
            anticipatePin: 1,
            start: "top top", // when the top of the trigger hits the top of the viewport
            end: "+=50%",
        }
    });
    

    //Pin Pond Text Top
    let pondTextTopTL = gsap.timeline({
        scrollTrigger: {
            scroller: ".smooth-scroll",
            scrub: true,
            trigger: "#pondTextTop",
            pin: true,
            start: "top top", // when the top of the trigger hits the top of the viewport
            end: "+=340%",
            onEnter: function () {
                updateSound(sounds.ENDING);
            },
            onLeave: function () {
                trackEvent("percentage_viewed", "percentage", 100);
            },
            onLeaveBack: function () {
                updateSound(sounds.INTRO);
            },
            onUpdate: function(self) {
                let perc = self.progress;
                let yPos1 = pondTop.y + window.innerHeight/1.2 - 250*perc;
                let yPos2 = pondTop.y + window.innerHeight/1.2 - 200*perc;
                
                gsap.set(pondParticles1, { pixi:{ y: yPos1 }});
                gsap.set(pondParticles2, { pixi:{ y: yPos2 }});
            },
        }
    });

    
    pondTextTopTL.to(".pond-text1", { opacity: 0, ease: "none", duration: 4 }, "+=6")
        .to(".pond-text2", { opacity: 1, ease: "none", duration: 2 }, "+=20")
        .to(".pond-text2", { opacity: 0, ease: "none", duration: 4 }, "+=8")

        .to(".pond-text3", { opacity: 1, ease: "none", duration: 2 }, "+=2")
        .to(".pond-text3", { opacity: 0, ease: "none", duration: 2 }, "+=6")
        .to(".pond-text4", { opacity: 1, ease: "none", duration: 2 }, "+=2")
        .to(".pond-text4", { opacity: 0, ease: "none", duration: 2 }, "+=6")
        .to(".pond-text5", { opacity: 1, ease: "none", duration: 2 }, "+=2")
        .to(".pond-text5", { opacity: 0, ease: "none", duration: 2 }, "+=6")
        .to(".trout", { right: 0, duration: 20 });
    //pondTextTopTL.to(pondParticles1, { pixi:{ y: "-=250px" }, duration: 30 }, "-=30");
    //pondTextTopTL.to(pondParticles2, { pixi:{y: "-=200px" }, duration: 30 }, "-=30");

    //pit end title animation
    let pitTL = gsap.timeline({
        scrollTrigger: {
            scroller: ".smooth-scroll",
            scrub: true,
            trigger: "#endTitle",
            start: "top top",
            end: "+=200%",
            onUpdate: function(self) {
                let perc = self.progress;
                
                let yPos = window.innerHeight/11*perc;
                //create parallax effect on pitFull
                gsap.set(pitFull, {pixi:{y:window.innerHeight/2 + pitText.offsetHeight-yPos}});
            }
        },
    });

    //pitTL.to(pitFull, {pixi:{y:"-=75px"}, duration: "100%"});


    
    
    setTimeout(function(){
        // each time the window updates, we should refresh ScrollTrigger and then update LocomotiveScroll. 
        ScrollTrigger.addEventListener("refresh", () => locoScroll.update());
        
        // after everything is set up, refresh() ScrollTrigger and update LocomotiveScroll because padding may have been added for pinning, etc.
        ScrollTrigger.refresh();

    }, 1000);

    

    
    

    

    locoScroll.on('call', func => {
        //consoleLogger(this);
        //consoleLogger(arguments);
        //consoleLogger(event);
        
        call(func);
        
    });

    function call(str) {

        if(disableCalls){
            consoleLogger("Calls disabled: don't send call");
            return;
        } else if(isMobile && window.innerWidth > window.innerHeight){
            consoleLogger("Mobile Landscape: don't send call");
            return;
        }

        //consoleLogger(str + ', direction: ' + direction);
        consoleLogger(">> call event: " + str + ", currentPhotoIndex: " + currentPhotoIndex + ", direction: " + direction);
        
        //Special treatment for strings
        switch (str) {
            case "END":
                consoleLogger("END CALLED: direction: " + direction + ", isMobile: " + isMobile);
                if (direction === "up") {
                    //go back up to story
                    if(!isMobile){
                        consoleLogger("END UP fadeToPhoto");
                        fadeToPhoto(photoOrder[currentPhotoIndex]);
                    }
                    document.getElementsByTagName("html")[0].classList.remove('gallery-mode');
                    document.getElementsByTagName("html")[0].classList.remove('is-ended');
                    
                } else {
                    //close and show gallery grid
                    document.getElementsByTagName("html")[0].classList.add('gallery-mode');
                    document.getElementsByTagName("html")[0].classList.add('is-ended');
                    hidePhotoGrid();
                    closePhotoSwiper(isMobile);
                }
                
                return;

            case "SHOW_NAV":
                if(isMobile && direction === "down"){
                    //only show nav when direction is down on mobile
                    showNav();
                } else if(direction === "down") {
                    showNav();
                } else if(document.getElementsByTagName("html")[0].classList.contains('is-ended')){
                    //direction is up but at the end
                    showNav();
                } else if(!document.getElementsByTagName("html")[0].classList.contains('is-ended')){
                    //direction is up and not at the end
                    hideNav();
                }
                //direction === "down" ? showNav() : hideNav();
                return;

            case "HIDE_NAV":
                if(isMobile && direction === "down"){
                    //only do down direction on mobile
                    hideNav();
                } else if(position > 0) {
                    direction === "down" ? hideNav() : showNav();
                }
                return;
        }

        if (direction === "up") {
            str -= 1;
            if (str < 0) str = 0;
        }


        if (str !== currentPhotoIndex) {
            consoleLogger("call: " + str + ", currentPhotoIndex: " + currentPhotoIndex);
            currentPhotoIndex = str;
            fadeToPhoto(photoOrder[str]);
        }

    }

    locoScroll.on('scroll', (args) => {
        
        if(!isMobile || isMobile && window.innerWidth < window.innerHeight){
            // Get all current elements : args.currentElements
            direction = args.direction;
            position = Math.ceil(args.scroll.y);
            limit = args.limit.y;
            ScrollTrigger.update();
        }
    
        if (!isMobile && document.getElementsByTagName("html")[0].classList.contains('is-ended')) {
            direction = "up"; //on desktop at the end, force direction up for future END event call
        }
        

        //show and hide NFB header based on scroll direction 
        try {
            if (direction === "down") {
                header.hide();
            } else {
                header.reveal();
            }
        } catch (e) {
            console.warn(e);
        }
    });

    function setVH(){
        let vh = window.innerHeight * 0.01;
        if(isMobile && window.innerWidth > window.innerHeight){
            vh = window.innerWidth * 0.01;
        }
        document.documentElement.style.setProperty('--vh', `${vh}px`);
        consoleLogger("resizeElements > setVH: " + vh);
    }

    function updateSound(snd){
        clearTimeout(soundChangeTimeout);
        soundChangeTimeout = setTimeout(function(){
            consoleLogger("canChangeSound: " + canChangeSound);
            if(canChangeSound){
                changeSound(snd);
            }
        }, 100);
    }

    function resizeElements() {
        clearTimeout(resizeTimeout);
        
        //remove fixed
        document.getElementsByTagName("html")[0].classList.remove('fixed')
        
        //document.getElementsByTagName("html")[0].style.height = window.innerHeight;
        resizeTimeout = setTimeout(function(){

            consoleLogger("resizeElements: isMobile: " + isMobile);
            setVH();

            windowHeight = window.innerHeight;
            windowWidth = window.innerWidth;
            
            //prevent calls and sound changes temporarily until resizing completes
            canChangeSound = false; //don't change sound
            disableCalls = true;    //prevent calls

            //document.getElementsByTagName("html")[0].style.height = "100%";


            //mobile landscape mode, switch to gallery
            if(isMobile && windowWidth > windowHeight){
                consoleLogger("canChangeSound: " + canChangeSound);

                //DISABLE LOCOSCROLL EVENTS
                consoleLogger("locoScroll > STOP");
                locoScroll.stop();

                windowHeight = window.innerWidth;
                windowWidth = window.innerHeight;
                document.body.style.position = "relative";
                //hide the NFB header
                consoleLogger("Mobile Landscape");
                showNav();
                document.getElementsByTagName("html")[0].classList.add('gallery-mode');

                currentPosition = position; //save currentPosition to use when switching back to portrait mode
                consoleLogger("landscape - currentPosition: " + currentPosition + ", position: " + position + ", limit: " + limit);
                
                

                clearTimeout(resizeOrientationTimeout);
                resizeOrientationTimeout = setTimeout(function(){
                    let galleryHeight = $("#gallery").height(); //windowWidth; //$("#gallery").height(); 
                    //let w = window.outerWidth; //$(window).width();
                    let h = Math.max(window.innerHeight, window.outerHeight); 
                    let t = h - galleryHeight;
                    
                    //resize photoswiper
                    resizePhotoSwiper(photoOrder[currentPhotoIndex]);


                    consoleLogger("window.innerHeight: " + window.innerHeight);
                    consoleLogger("window.outerHeight: " + window.outerHeight);
                    consoleLogger("make lh-gallery draggable t: " + t + ", h: " + h + ", galleryHeight: " + galleryHeight);
                    

                    draggableGrid = Draggable.create("#gallery", {type:"y", inertia: true, bounds:{minY:h-galleryHeight, maxY:0}});
                }, 50);
                
                return;
                
            } else if(isMobile && windowWidth < windowHeight){
                //mobile portrait mode
                
                consoleLogger("Mobile Portrait");

                $(".smooth-scroll").width(windowWidth+"px");

                //switch out of gallery if not ended
                if (!document.getElementsByTagName("html")[0].classList.contains('is-ended')) {
                    consoleLogger("not ENDED, switch out of gallery mode");
                    document.getElementsByTagName("html")[0].classList.remove('gallery-mode');
                }


                //scroll to current position
                clearTimeout(resizeOrientationTimeout);

                resizeOrientationTimeout = setTimeout(function(){
                    consoleLogger("locoScroll > START");
                    document.getElementsByTagName("html")[0].classList.add('fixed');
                    locoScroll.start();
                    ScrollTrigger.refresh();
                    
                    if(currentPosition > 0 ){
                        //disableCalls = true;
                        consoleLogger("portrait - currentPosition: " + currentPosition);

                        if(locoScroll){
                            consoleLogger("locoScroll > scrollTo: " + currentPosition + ", position: "+ position + ", limit: " + limit);
                            locoScroll.scrollTo(currentPosition, { duration: 5, disableLerp: true });
                        }
                    }
                    if (!document.getElementsByTagName("html")[0].classList.contains('is-ended')) {
                        //fade to current photo if not ended
                        consoleLogger("fadeToPhoto: " + photoOrder[currentPhotoIndex]);
                        fadeToPhoto(photoOrder[currentPhotoIndex]);
                    }
                    
                }, 50);
                
            }

            //consoleLogger("windowWidth: " + windowWidth + ", windowHeight: " + windowHeight);
            //consoleLogger("smoothScroll height: " + smoothScroll.offsetHeight);
            
            //move smoothScroll out of viewport if in gallery mode and NOT at end
            if(document.getElementsByTagName("html")[0].classList.contains('gallery-mode') && !document.getElementsByTagName("html")[0].classList.contains('is-ended')){
                //gsap.to(smoothScroll, 0.5, { x: "100%", ease: "Quad.easeOut" });
                gsap.to(smoothScrollWrapper, 0.5, { x: "101%", ease: "Quad.easeOut" });
                //make sure gallery nav is visible
                showNav();
            }
            if(!isMobile || isMobile && windowWidth < windowHeight){
                //resize elements only if NOT mobile or mobile portrait orientation
                fillScreenAndCenter(trainAnimation);
                resizeAnimation(snareAnimation);
                resizeAnimation(skinAnimation);
                resizeAnimation(raccoonAnimation);
                resizeAnimation(featherAnimation);
                resizeAnimation(hareAnimation);
                resizeAnimation(pondBg, 0, false);
                resizeAnimation(pondText, 0, false);
                resizeElsWithClass("train-text-wrapper", 657);
                resizePixiElements();
                
                clearTimeout(resizeCompleteTimeout)
                resizeCompleteTimeout = setTimeout(function(){
                    ScrollTrigger.refresh();
                    consoleLogger("refresh ScrollTrigger which updates locoScroll");
                    
                    //reenable calls and sounds to update
                    canChangeSound = true;
                    disableCalls = false;
                }, 500);

                consoleLogger("resizeElements > windowWidth: " + windowWidth + ", windowHeight: " + windowHeight + ", smoothScroll.offsetHeight: " + smoothScroll.offsetHeight);
            }    
            
        }, 250);
    }

    //RESIZE PIXI ELEMENTS
    function resizePixiElements(){
        // render train scene
        trainScene.renderer.render(trainScene.stage);

        pondScale = Math.min(window.innerWidth/pondWidth, 1);
        pitBgMaxHeight = window.innerHeight * 0.6 + pitText.offsetHeight + 1225*pitScale;

        //pitBgScale = Math.min(window.innerHeight*2.2/pitBgHeight, 1);
        pitBgScale = pitBgMaxHeight/pitBgHeight;

        if(pitBgWidth * pitBgScale < window.innerWidth){
            pitBgScale = window.innerWidth/pitBgWidth;
        }
        pitScale = Math.min(window.innerWidth/pitWidth, 1);

        consoleLogger("pitBgMaxHeight: " + pitBgMaxHeight);
        consoleLogger("pitScale: " + pitScale);
        consoleLogger("pitBgScale: " + pitBgScale);

        //set scale of pond elements
        pondClouds.scale.set(pondScale);
        pondTreeline.scale.set(pondScale);
        pondSurface.scale.set(pondScale);
        pondTop.scale.set(pondScale);
        pondBottom.scale.set(pondScale);
        pondParticles1.scale.set(pondScale);
        pondParticles2.scale.set(pondScale);
        pitBackground.scale.set(pitBgScale);
        pitFull.scale.set(pitScale);
        //pitBgScene.renderer.resize(window.innerWidth, window.innerHeight*2.2);
        pitBgScene.renderer.resize(window.innerWidth, pitBgMaxHeight);
        pitBgScene.renderer.render(pitBgScene.stage);

        $(".pit-bg-wrapper").height(pitBgMaxHeight); //set wrapper
        
        //position pond y elements
        pondTreeline.y = window.innerHeight - 238*pondScale; 
        pondSurface.y = pondTreeline.y + 238*pondScale + window.innerHeight/2;
        pondTop.y = pondSurface.y + 103*pondScale;
        pondBottom.y = pondTop.y + 921*pondScale - 1;
        pondParticles1.y = pondTop.y + window.innerHeight/1.2;
        pondParticles2.y = pondTop.y + window.innerHeight/1.2 + 200;
        pondScene.renderer.resize(570, pondBottom.y + 575*pondScale);
        pondScene.renderer.render(pondScene.stage);
        pitBackground.y = 0;
        pitBackground.x = window.innerWidth/2 - pitBgWidth*pitBgScale/2;
        if(pitBgHeight*pitBgScale > pitBgMaxHeight){
            pitBackground.y = pitBgMaxHeight - pitBgHeight*pitBgScale;
        } 
        //pitBackground.y = window.innerHeight*2.2 - pitBgHeight*pitBgScale;
        consoleLogger("pitBackground.y: " + pitBackground.y + ", pitBgMaxHeight: " + pitBgMaxHeight + ", pitBgHeight*pitBgScale: "+ pitBgHeight*pitBgScale);
        pitFull.x = window.innerWidth/2 - pitWidth*pitScale/2;
        pitFull.y =  window.innerHeight/2 + pitText.offsetHeight; //*pitScale;
        
        //pitFull.y =  pitBgHeight*pitBgScale - 1225*pitScale;
    }
    
    //resize the animation to fit mobile if necessary
    function resizeAnimation(el, m = 30, adjustBottomMargin = true) {
        if (el) {
            let w = el.offsetWidth;
            let h = el.offsetHeight;
            let margin = m;
            let mb;
            let s = (windowWidth - margin) / el.offsetWidth;

            mb = h * s - el.offsetHeight + 25;
            
            if (s < 1) {
                el.style.transform = "scale(" + s + ")";
                if(adjustBottomMargin){
                    el.style.marginBottom = mb + "px";
                }
            } else {
                el.style.transform = "scale(1)";
            }
        }
    }

    //needed for elements to fill the entire screen
    function fillScreenAndCenter(el) {
        if (el) {

            let s = windowWidth / (el.offsetWidth - 5);
            let h = el.offsetHeight * s;
            let w, x = 0, y = 0;
            let winH = Math.max(window.innerHeight, window.outerHeight);

            consoleLogger("h: " + h)
            if (h < winH) {
                //bg too short, get new scale based on height
                consoleLogger("bg too short")
                s = winH / (el.offsetHeight - 5);
            }

            w = el.offsetWidth * s;
            h = el.offsetHeight * s;

            if (w > windowWidth) {
                x = Math.round((windowWidth - w) / 2);
            }
            //center vertically if portrait
            if (h > windowHeight && windowWidth < windowHeight) {
                y = Math.round((windowHeight - h) / 2);
            }

            //consoleLogger("scale: " + s + ", w: " + w + ", x: " + x + ", y: " + y);
            trainAnimation.style.marginLeft = x + "px";
            trainAnimation.style.marginTop = y + "px";
            trainAnimation.style.transform = "scale(" + s + ")";

        }
    }

    function resizeElsWithClass(className, elWidth) {
        //resize text train wrapper
        var els = document.getElementsByClassName(className);
        let x, s;
        for (var i = 0; i < els.length; i++) {
            s = windowWidth / elWidth;
            if (s < 1) {
                s = s;
                x = (windowWidth - elWidth) / 2;
                consoleLogger("s: " + s + ", x: " + x);
                els[i].style.transform = "scale(" + s + ")";
                els[i].style.marginLeft = x + "px";
            }
        }
    }

    //set window resize listener
    window.addEventListener('resize', resizeElements);
}

function consoleLogger(msg){
    //console.log(msg);
}
